import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { getIndConditionApi, deleteIndConditionApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import { InductionConditionList, InductionConditionCRU, InductionConObj } from '../components';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { PageLoader, STableLoader, Pagination } from '../../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const InductionConditionHd = ({ createSortHandler, sortInfo, item, bulk, toggleBulkOps }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Induction Condition`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['D'] }}>
                        <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /> </PermissionWrapper>
                    Action(s)
                </TableCell> 
                <TableCell sx={{ minWidth: '150px', }}> {tableSorting('asset_conditions_for_contract__name', 'Clause')}</TableCell>
                <TableCell sx={{ minWidth: '150px' }}> {tableSorting('terms', 'Terms')}</TableCell>
                <TableCell sx={{ minWidth: '150px' }}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}
const InductionCondition = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const dispatch = useDispatch()
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [inductionConditionDetails, setInductionConditionDetails] = useState({ list: [], pagination: {} });
    const [inductionConditionCRU, setInductionConditionCRU] = useState({ modal: false, data: null, mode: '' });
    const [deleteInductionCondition, setDeleteInductionCondition] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const [isExport, seIsExport] = useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
       const uploadedFileData = getApiResponse("induction_conditions", slug);
        getInductionList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Induction Condition' })
       setUploadFileProgressData({uploadedFileData});

    }, [])

    const getInductionList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getIndConditionApi(params, query))
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setInductionConditionDetails(response.data.data);
                }
            })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "induction_conditions" }))
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (inductionConditionCRU?.modal) {
            setInductionConditionCRU({
                ...inductionConditionCRU,
                data: {
                    ...inductionConditionCRU.data,
                    attachments: inductionConditionCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getInductionList('', { per_page: inductionConditionDetails?.pagination?.per_page || 50 });
    }
    const deleteIcFn = () => {
        setLoading(true);
        const idsToDelete = deleteInductionCondition?.modal && deleteInductionCondition?.data?.id ? [deleteInductionCondition?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteIndConditionApi(params), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Induction Condition`, success_msg: response?.data?.message, item_ids: deleteInductionCondition?.data || bulk?.ids, response: response?.data })
                    setDeleteInductionCondition({ modal: false, data: null });
                    getInductionList('', { per_page: inductionConditionDetails?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Induction Condition`, error_msg: response?.data?.message, item_ids: deleteInductionCondition?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getInductionList('', { ...sortQuery, per_page: inductionConditionDetails?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getIndConditionApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Induction Condition`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
         setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "induction_conditions",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
                setUploadFileProgressData({ progressRefs, attachments,response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getInductionList("", { per_page: inductionConditionDetails?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
       setSlug({})

    };


    return (
        <>
        <LeasesBasicDetails/>
         <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="terms"/>
            <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Induction Condition" type="terms"/>
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" color='error' size="small">{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {inductionConditionDetails?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { setInductionConditionCRU({ modal: true, data: InductionConObj, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Induction Condition </Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: inductionConditionDetails?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <InductionConditionHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={inductionConditionDetails?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {inductionConditionDetails?.list?.length > 0 && inductionConditionDetails?.list?.map((item, index) => {
                                            const uploadedFileData = getApiResponse("induction_conditions", item?.slug);
                                        
                                        return (
                                            <InductionConditionList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                onEditFn={() => setInductionConditionCRU({ modal: true, data: item, mode: 'edit' })}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onView={() => setInductionConditionCRU({ modal: true, data: item, mode: 'view' })}
                                                onDeleteIcFn={() => {
                                                    setDeleteInductionCondition({ modal: true, data: item });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                            />
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && !inductionConditionDetails?.list?.length && <NoRecordFound />}
                    </div>
                    <Paper square>
                        <Pagination
                            pagination={inductionConditionDetails?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getInductionList("pageloader", { page: pageNum, per_page: inductionConditionDetails?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getInductionList("pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
        </Paper>
            {inductionConditionCRU.modal &&
                <InductionConditionCRU
                    fileUpload={handleUpload}
                    inductionConditionCRU={inductionConditionCRU}
                    modeType={inductionConditionCRU?.mode}
                    getResponseBack={() => {getInductionList('', { per_page: inductionConditionDetails?.pagination?.per_page }); setBulk({modal: false, ids: [], title: '', type: ''})}}
                    onOpenAttachments={() => setAttachments({ modal: true, data: inductionConditionCRU?.data, mode:'view' })}
                    onToggleModal={() => setInductionConditionCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Induction Condition"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={inductionConditionCRU?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='induction_conditions'
                /> : null
            }
            {deleteInductionCondition.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteInductionCondition.modal}
                    title={`Delete ${bulk?.modal ? (bulk?.ids?.length === (inductionConditionDetails?.list?.length || 0) ? 'All Induction Conditions' : 'Selected Induction Conditions') : 'Induction Condition'}`}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (!bulk.modal) {
                            setDeleteInductionCondition({ modal: false, data: null });
                        }
                        setBulk({ modal: false, ids: [], title: '', type: '' });
                    }}
                    onDeleteRecords={() => deleteIcFn()}
                /> : null}
            {
            revisionHistory.modal &&  
            <RevisionHistory 
             moduleName={"induction_conditions"}
             revisionHistory={revisionHistory}
             onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
            />
            }   
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(InductionCondition, { application: 'lease_revamp', feature: 'induction_conditions', operationType: ['R'] });
